import * as CourierModels from '../../models/couriers/courier';


export class Get {
  static readonly type = '[Courier] Get';
  constructor(public CourierId: number) {}
}

export class Set {
  static readonly type = '[Courier] Set';
  constructor(public Courier: CourierModels.CourierModel) { }
}

export class GetList {
  static readonly type = '[Courier] List';
  constructor() { }
}

export class Delete {
  static readonly type = '[Courier] Delete';
  constructor(public CourierId: number) { }
}

export class GetDictionary {
  static readonly type = '[Courier] Dictionary';
  constructor() { }
}

export class ImportDPDVerificationFile {
  static readonly type = '[Courier] Import DPD Verification File';
  constructor(public FileName: string, public Data: any) { }
}

// this action state is responsible for clear the upload form,
export class SetImportDPDVerificationFileStatus {
  static readonly type = '[Courier] Set Import DPD Verification File Status';
  constructor(public Status: boolean) { }
}
